import request from '@/utils/request'

// 查询企业微信-客户标签组列表
export function listExternalUserTagGroup(query) {
    return request({
        url: '/wxCp/externalUserTagGroup/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信-客户标签组详细
export function getExternalUserTagGroup(id) {
    return request({
        url: '/wxCp/externalUserTagGroup/' + id,
        method: 'get'
    })
}

// 新增企业微信-客户标签组
export function addExternalUserTagGroup(data) {
    return request({
        url: '/wxCp/externalUserTagGroup',
        method: 'post',
        data: data
    })
}

// 修改企业微信-客户标签组
export function updateExternalUserTagGroup(data) {
    return request({
        url: '/wxCp/externalUserTagGroup/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信-客户标签组
export function delExternalUserTagGroup(id) {
    return request({
        url: '/wxCp/externalUserTagGroup/delete/' + id,
        method: 'post'
    })
}
